'use client'
import {usePathname, useSearchParams} from 'next/navigation'
import Script from 'next/script'
import React, {useEffect, useState} from 'react'

const FacebookPixel = () => {
  const [cookieConsent, setCookieConsent] = useState(false)
  const searchParams = useSearchParams()
  const pathname = usePathname()

  useEffect(() => {
    if (pathname && cookieConsent) {
      window.fbq('track', 'PageView')
    }
  }, [pathname, searchParams, cookieConsent])

  useEffect(() => {
    const localCookieConsent = localStorage.getItem('cookieConsent') as
      | 'DENIED'
      | 'GRANTED'
    if (localCookieConsent === 'GRANTED') {
      setCookieConsent(true)
    }
  }, [])

  return cookieConsent ? (
    <Script id="facebook-pixel">
      {`
        !function(f, b, e, v, n, t, s) {
          if (f.fbq) return;
          n = f.fbq = function() {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
          };
          if (!f._fbq) f._fbq = n;
          n.push = n;
          n.loaded = !0;
          n.version = '2.0';
          n.queue = [];
          t = b.createElement(e);
          t.async = !0;
          t.src = v;
          s = b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t, s);
        }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      
        window.fbq('init', '2773073206115064');
        window.fbq('track', 'PageView');
      `}
    </Script>
  ) : null
}

export default FacebookPixel
